import type { JSX } from 'react';
import { ResultCount } from '@/shared/components/ResultCount';

function CenteredMessage({ children, tone }: { children: string; tone?: string }): JSX.Element {
  return (
    <div className="flex items-center justify-center p-8">
      <p className={tone ?? 'text-muted-foreground'}>{children}</p>
    </div>
  );
}

export function CandidatesLoadingState(): JSX.Element {
  return <CenteredMessage>Loading candidates...</CenteredMessage>;
}

export function CandidatesErrorState(): JSX.Element {
  return <CenteredMessage tone="text-destructive">Failed to load candidates</CenteredMessage>;
}

export function CandidatesEmptyState(): JSX.Element {
  return (
    <div className="space-y-4">
      <ResultCount count={0} />
      <div className="flex flex-col items-center justify-center p-8 border rounded-md">
        <p className="text-muted-foreground mb-2">No candidates linked to this position yet.</p>
        <p className="text-sm text-muted-foreground">
          Click &quot;Add Candidate&quot; to link candidates.
        </p>
      </div>
    </div>
  );
}
